import { BetBarValueText } from "slotworks/components/betbar/bet-bar-value-text";

export class AgsBetBarValueText extends BetBarValueText {

    public update(value: number) {
        super.update(value);
    }
}
